import { doc, getFirestore, setDoc } from "firebase/firestore";
import { UniformRequest, UniformRequestType } from "../types/UniformRequest";
import { Employee } from "../types/Employee";
import { v4 as uuidv4 } from 'uuid';
import { DateTime } from "luxon";

export const createUniformRequest = async (employee: Employee, type: UniformRequestType) => {
  try {
    const uniformRequest: UniformRequest = {
      id: uuidv4(),
      idNumber: employee.idNumber,
      name: employee.name,
      type,
      dateRequested: DateTime.utc().toISO(),
      status: 'New',
      lastUpdate: DateTime.utc().toISO(),
    };
    const db = getFirestore();
    await setDoc(doc(db, `Employees/${uniformRequest.idNumber}/UniformRequests/${uniformRequest.id}`), uniformRequest);
    return true;
  } catch {
    return false;
  }
};